import { Theme } from '@mui/material'

const useStyles = {
  dialogTitle: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingRight: theme.spacing(2),
  }),
  closeIcon: {
    color: '#0000008C', // 8C adds 55% opacity
  },
  divider: (theme: Theme) => ({
    margin: theme.spacing(0, 3),
  }),
}
export default useStyles
